import React from "react";
import { Link } from "react-router-dom";
import "./current.scss";
import Image4 from "../../assets/images/research6.png";
export const CurrentUnderG = () => {
  return (
    <>
      {" "}
      <div className="current-graduates-page">
        <center>
          <h1>Current Undergraduates</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Studying physics</h6>
        </div>
      </div>
      <center>
        <div className="col-md-5 mt">
          <p>
            <strong>
              {" "}
              This page provides an overview on currently available
              undergraduate course and links to useful information for current
              students.{" "}
            </strong>
          </p>
          <p>
            <strong>
              {" "}
              Current staff and students will find further details by logging in
              to the <Link className="links">Teaching Information System.</Link>
            </strong>
          </p>
        </div>
      </center>
      <div className="col-md-8 offset-md-2 mt current-body">
        <div className="flexy">
          <div className="col-md-6">
            <h6>Current courses</h6>
            <Link to={"/course-page"} className="links">
              All Departmental Courses
            </Link>
            <h6>Useful Resources </h6>
            <ul>
              <li>
                {" "}
                <Link className="links">
                  Teaching Information System (TIS){" "}
                </Link>
              </li>
              <li>
                {" "}
                <a href="#" className="links">
                  Physics Course Handbook (pdf)
                </a>
              </li>
              <li>
                <Link>Online lecture timetable</Link>
              </li>
              <li>
                <Link>Guide to Keeping Laboratory Notes (pdf)</Link>
              </li>
            </ul>
            <h6>Examinations</h6>
            <ul>
              <li>Departmental Plagiarism policy</li>
              <li>Exam timetables</li>
              <li>Form and conduct notices</li>
              <li>Examination question types</li>
              <li>How the examiners work</li>
              <li>Examination skills</li>
              <li>Advice on answering essay and brief notes questions</li>
              <li>Examination data retention policy</li>
            </ul>
            <h6>Governance and Policy</h6>
            <ul>
              <li>Committees</li>
              <li>Transferable skills policy</li>
              <li>Physics core competencies</li>
              <li>Coursework Extension Policy</li>
            </ul>
          </div>
          <div className="col-md-6">
            {" "}
            <img className="" src={Image4} alt="Scholar" width="100%" />
            <p className="mt4">
              The minimum entry requirement for admission to the Bachelor’s
              degree programme in the Department of Physics in accordance with
              the minimum academic standard of the National University
              Commission (NUC) is five (5) credits passes at not more than two
              sittings in the West African School Certificate (WASC), or Senior
              School Certificate Examination (SSCE) or (NECO) or NABTECH
              examination. The credits must include English Lan­guage,
              Mathematics, Physics, Chemistry and Biology or Agricultural
              Science.
            </p>
            <p>
              The candidate can also be admitted into 200 level through the
              direct entry programme. The admission requirement for this
              category is as stated be­low:
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
